import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={waLink("Hello Sagar Darshan Guest House, I would like to enquire about a stay.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl shadow-navy/30 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:scale-105"
    >
      <MessageCircle size={26} strokeWidth={1.8} />
    </a>
  );
}
